import { apiRequest, clearAuth } from './api';
import type { LoginCredentials, LoginResponse, RefreshTokenRequest, RefreshTokenResponse } from '@/types';
import { STORAGE_KEYS } from '@/config/api';

export const authService = {
  /**
   * Realiza login do usuário
   */
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await apiRequest<LoginResponse>(
      '/auth/login',
      {
        method: 'POST',
        body: JSON.stringify(credentials),
        skipAuth: true,
      }
    );

    // Salvar tokens no localStorage
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, response.authToken);
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, response.expToken);

    return response;
  },

  /**
   * Renova os tokens de autenticação
   */
  async refreshToken(expToken: string): Promise<RefreshTokenResponse> {
    const response = await apiRequest<RefreshTokenResponse>(
      '/auth/refresh',
      {
        method: 'POST',
        body: JSON.stringify({ expToken } as RefreshTokenRequest),
        skipAuth: true,
      }
    );

    // Atualizar tokens no localStorage
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, response.authToken);
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, response.expToken);

    return response;
  },

  /**
   * Realiza logout do usuário
   */
  logout(): void {
    clearAuth();
  },

  /**
   * Verifica se o usuário está autenticado
   */
  isAuthenticated(): boolean {
    return !!localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  },
};
